import { render, staticRenderFns } from "./AffiliationEditor.vue?vue&type=template&id=46842cd5&"
import script from "./AffiliationEditor.vue?vue&type=script&lang=js&"
export * from "./AffiliationEditor.vue?vue&type=script&lang=js&"
import style0 from "./AffiliationEditor.vue?vue&type=style&index=0&id=46842cd5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports